import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import styled from 'styled-components';
import { animated } from 'react-spring';
import { useFormTransition } from '../../../utils/hooks/useFormTransition';

import { Section } from '../../layout/Section';
import { Container } from '../../layout/Container';
import { BackgroundLoad } from '../../layout/BackgroundLoad';
import { Thanks } from '../../layout/Thanks';

import { Heading } from '../../ui/text/Heading';
import { Paragraph } from '../../ui/text/Paragraph';

import { AccordionGeneral } from '../../partials/AccordionGeneral';
import { AccordionBenefits } from '../../partials/AccordionBenefits';
import { useFadeTransition } from '../../../utils/hooks/useFadeTransition';
import { Seo } from '../../../utils/seo/Index';

import { AboutValuationText } from '../../partials/AboutValuationText';
import { PageType } from '../../../__types__/generated/globalTypes';
import { useValuationContext } from '../../../utils/hooks/useValuationContext';
import { ValuationForm } from '../../partials/forms/Valuation';

const ValuationGeneral2: React.FC = () => {
  const { posted, init } = useValuationContext();

  React.useEffect(() => {
    init({
      pageType: PageType.GENERELL
    });
  }, []);

  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true
  });

  const { fadeIn, fadeOut } = useFormTransition({
    posted
  });

  return (
    <>
      <Seo
        title="Salg av eiendom? - PrivatMegleren"
        description="Som kunde hos PrivatMegleren får du en skreddersydd prosess tilpasset dine behov og ønsker."
      />
      <Container className="padding-top" style={pageFadeIn}>
        <FormWrapper style={fadeOut}>
          <Section className="form-section" style={{ paddingBottom: '10px' }}>
            <Heading tag="h1" center={true}>
              9 av 10 velger PrivatMegleren etter anbefaling fra andre
            </Heading>
            <Paragraph center={true} className="form-text">
              At tidligere kunder anbefaler oss videre, er en av de største
              tillitserklæringene vi får. PrivatMegleren har også blitt kåret
              til Norges beste eiendomskjede av Norsk Kundebarometer i 2022.*
            </Paragraph>
            <Paragraph center={true} className="form-text">
              Vi mener dette er fordi vi skreddersyr et hvert eiendomssalg, med
              et felles mål om et salg som overgår bransjens standard, og som
              gir deg det beste resultatet. I tillegg til en rekke innovative
              verktøy, som gjør hele prosessen betydelig bedre, mer oversiktlig
              og enklere. Velger du PrivatMegleren, får du tilgang på mange av
              Norges fremste eiendomsmeglere.
            </Paragraph>
            <Paragraph center={true} className="form-text">
              Et godt samarbeid starter med en nyttig og god samtale. Ta
              kontakt, så hører du i fra oss.
            </Paragraph>
          </Section>
          <ValuationForm />

          <Section className="form-section">
            <AboutValuationText />
          </Section>
          <Section className="form-section">
            <AccordionBenefits />
          </Section>
        </FormWrapper>
        <Thanks style={fadeIn}>
          <Section className="form-section">
            <Heading tag="h1" center={true}>
              Tusen takk
            </Heading>
            <Paragraph center={true}>
              En eiendomsmegler vil ta kontakt med deg så snart som mulig.
            </Paragraph>
            <Paragraph center={true}>
              I mellomtiden kan du lese mer om salg av eiendom her.
            </Paragraph>
            <AccordionGeneral />
          </Section>
          <Section className="form-section" style={{ paddingTop: 0 }}>
            <AccordionBenefits />
          </Section>
        </Thanks>
      </Container>
      <BackgroundLoad
        opacity={0.3}
        url="https://cdn.reeltime.no/pm_assets/img/verdivurdering.jpg"
      />
    </>
  );
};

export default ValuationGeneral2;

const FormWrapper = styled(animated.div)``;
